import { replaceUnderscores, TertiaryEducationTypeTypes } from "~/common/utils";
import { YES_NO_TYPES } from "~/common/utils/consultations/intake/data/intakeQuestionsData";
import { TertiaryEducationDetail } from "~/providers/utils/types/rawResponsesTypes";

export const formatGraduateSchoolOrCollegeAnswers = (
  answer: TertiaryEducationDetail[],
  type: TertiaryEducationTypeTypes,
) =>
  answer.map(
    ({ did_you_attend, name, degree, year_started, year_ended, graduated }) => {
      const graduationText = `I have ${
        graduated ? `graduated` : `not graduated`
      } from ${replaceUnderscores(type)}.`;
      const periodYears = year_ended
        ? `${year_started} - ${year_ended}`
        : `${year_started}`;

      if (did_you_attend === YES_NO_TYPES.no) {
        return did_you_attend;
      }

      return `${did_you_attend}, ${name}, ${degree}, ${periodYears}, ${graduationText}`;
    },
  );
